<template>
  <s-modal
    v-model="showModal"
    class="temporary-password"
    footer-class="temporary-password__footer"
    ok-only
    :title="$t(`user-manager.reset-password-modal.online.title`)"
    :ok-title="$t(`user-manager.reset-password-modal.online.close-button`)"
    @ok="closeModal"
    @hide="closeModal"
  >
    <div class="temporary-password__content">
      <div class="temporary-password__icon">
        <img
          src="/static/imgs/send-email-green.png"
          alt="Email Icon"
        />
      </div>
      <div
        class="temporary-password__message"
        v-html="$t('user-manager.reset-password-modal.online.message', {
          eMail,
        })"
      >
      </div>
    </div>
  </s-modal>
</template>

<script>
export default {
  data: () => ({
    eMail: null,
    showModal: false,
  }),
  methods: {
    show(eMail) {
      this.eMail = eMail;
      this.showModal = true;
    },
    closeModal() {
      this.$emit('ok');
      this.eMail = null;
      this.showModal = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .temporary-password
    &__message
      text-align: center
    &__content
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
    &__icon
      margin-bottom: 1.5em
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>
